<div class="logo" [ngClass]="[theme, loginClass]">
  <a routerLink="/" aria-label="Link to cloud gateway Portal">
    <img class="logo__image" src="{{ logoPath }}" alt="Cloud Gateway logo" />
  </a>
</div>
